"use client";

import { Ear } from "lucide-react";

import { Button } from "../../ui/Button";
import { WECKWORT_HINWEIS_TEXT } from "../../../lib/weckwort-hinweis";

/** Zwischenspeicher der Registrierung, den `OnboardingApplier` nach dem ersten Login anwendet. */
export const ONB_STASH_KEY = "janeway_onboarding";

/**
 * Schritte des Registrierungs-Assistenten. `jane` (Weckwort-Spec §5) steht hinter `register` und nur,
 * wo es Jane gibt — und nicht bei der Einladung: deren Abschluss leitet sofort weiter, es gibt keinen
 * Platz fuer einen weiteren Schritt.
 */
export function onboardingSchritte(o: { jane: boolean; einladung: boolean }): readonly string[] {
  return o.jane && !o.einladung ? ["design", "workspace", "register", "jane"] : ["design", "workspace", "register"];
}

/**
 * Die Wahl reist im Zwischenspeicher der Registrierung mit: zum Zeitpunkt der Registrierung gibt es
 * noch keine Sitzung (Bestaetigungsmail), die Einwilligung schreibt `OnboardingApplier` nach dem
 * ersten echten Login. Ohne Zwischenspeicher gibt es nichts anzuwenden.
 */
export function merkeWeckwortWahl(an: boolean): void {
  try {
    const roh = window.localStorage.getItem(ONB_STASH_KEY);
    if (!roh) return;
    const stash = JSON.parse(roh) as Record<string, unknown>;
    window.localStorage.setItem(ONB_STASH_KEY, JSON.stringify({ ...stash, weckwort: an }));
  } catch {
    // Kein Speicher oder kaputtes JSON: dann eben nicht; einschalten geht spaeter in den Einstellungen.
  }
}

/**
 * Zwei GLEICHWERTIGE Knoepfe, keine Vorauswahl, kein vorab gesetzter Fokus: eine Einwilligung nach
 * Art. 7 DSGVO darf nicht durch Gestaltung nahegelegt werden.
 */
export function JaneSchritt({ onWahl }: { onWahl: (an: boolean) => void }) {
  const knopf = "min-h-11 w-full";
  return (
    <div className="space-y-5">
      <div className="flex h-14 w-14 items-center justify-center rounded-[var(--radius)] bg-primary">
        <Ear size={26} className="text-primary-foreground" aria-hidden="true" />
      </div>
      <div className="space-y-1.5">
        <h1 className="text-[1.7rem] font-semibold leading-[1.12] tracking-tight">„Hey Jane“ einschalten?</h1>
        <p className="text-sm text-muted-foreground">{WECKWORT_HINWEIS_TEXT}</p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Button type="button" variant="outline" className={knopf} onClick={() => onWahl(false)} aria-label="Nicht jetzt">
          Nicht jetzt
        </Button>
        <Button type="button" variant="outline" className={knopf} onClick={() => onWahl(true)} aria-label="Einschalten">
          Einschalten
        </Button>
      </div>
    </div>
  );
}
